import { Provider, Type } from '@angular/core';

export function provideListViewQuickFilterKeys(service: Type<ListViewQuickFilterKeysService>): Provider {
  return {
    provide: ListViewQuickFilterKeysService,
    useClass: service,
  };
}

export abstract class ListViewQuickFilterKeysService {
  abstract getPrivateQuickFilterKey(): string;
  abstract getPublicQuickFilterKey(): string;
}
